import type { IRecognitionResult } from './recognitionResult';
import { recognitionResultSchema } from './recognitionResult';
import { Joi, objectSchemaOf } from '../helpers';

export const sendMessageAsUserParamsSchema = objectSchemaOf<ISendMessageAsUserParams>(
  {
    consoleId: Joi.string().required(),
    organisationId: Joi.string().required(),
    conversationId: Joi.string().required(),
    recordingId: Joi.string().required(),
    recognitionResult: recognitionResultSchema.required(),
    messageId: Joi.string(),
  }
);

export interface ISendMessageAsUserParams {
  consoleId: string;
  organisationId: string;
  conversationId: string;
  recordingId: string;
  recognitionResult: IRecognitionResult;
  messageId?: string;
}
